var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 10C11.5117 10 13.75 7.76133 13.75 5C13.75 2.23867 11.5117 0 8.75 0C5.98828 0 3.75 2.23867 3.75 5C3.75 7.76133 5.98828 10 8.75 10ZM10.7305 11.875H6.76953C3.03008 11.875 0 14.9062 0 18.6445C0 19.3945 0.60625 20 1.35391 20H16.1445C16.8945 20 17.5 19.3945 17.5 18.6445C17.5 14.9062 14.4687 11.875 10.7305 11.875ZM18.7148 12.5H15.8301C17.625 13.9727 18.75 16.1758 18.75 18.6445C18.75 19.1445 18.6016 19.6055 18.3594 20H23.75C24.4414 20 25 19.4375 25 18.7148C25 15.2969 22.2031 12.5 18.7148 12.5ZM16.875 10C19.293 10 21.25 8.04297 21.25 5.625C21.25 3.20703 19.293 1.25 16.875 1.25C15.8941 1.25 14.9984 1.58418 14.2688 2.1293C14.7188 2.99336 15 3.96094 15 5C15 6.3875 14.534 7.66172 13.766 8.69961C14.5586 9.5 15.6562 10 16.875 10Z",
    fill: "#498CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.86c6d446a50c175872cb63c911af4238.svg";
export { ForwardRef as ReactComponent };